import { jobTypes } from "@/features/job/const/jobTypes";
import { JobTypeEnum } from "@/generated/graphql-hooks";

const { [JobTypeEnum.Others]: _, ...modelPrefJobTypes } = jobTypes;

export { modelPrefJobTypes };
